import { type InputHTMLAttributes, forwardRef } from 'react'

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { label, error, className = '', id, ...rest },
  ref
) {
  return (
    <div>
      {label && (
        <label htmlFor={id} className="mb-1 block text-sm font-medium text-body">
          {label}
        </label>
      )}
      <input
        id={id}
        ref={ref}
        className={`w-full rounded-md border px-3 py-2 text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500/40 sm:text-sm ${error ? 'border-danger-500' : 'border-border-strong'} ${className}`}
        {...rest}
      />
      {error && <p className="mt-1 text-xs text-negative">{error}</p>}
    </div>
  )
})
